export const authActionTypes = {
	LOGIN: "LOGIN",
	VERIFY_TOKEN: "VERIFY_TOKEN",
};
